var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * 用于调试事件监听器泄露
 * @example
 * ```ts
 * window['lm'] = new ListenerMonitor(window) // 监控window上的事件注册，每隔1s打印出来各个事件上注册的监听器的数量
 * // 在console 上
 *
 * lm.stopLog()// 关闭日志
 * lm.listenerSnaps['scroll'] // 查看scroll事件绑定过的监听器方便定位到源码
 * ```
 */
var ListenerMonitor = /** @class */ (function () {
    function ListenerMonitor(target, _options) {
        if (_options === void 0) { _options = {}; }
        var _this = this;
        this.target = target;
        this.listenerCounter = {};
        this.listenerSnaps = {};
        var options = this.options = __assign({ on: 'addEventListener', off: 'removeEventListener', interval: 1000, events: [], autoStartLog: true }, _options);
        var on = target[options.on];
        var off = target[options.off];
        var init = function (event) {
            if (options.events.length && !options.events.includes(event)) {
                return false;
            }
            _this.listenerCounter[event] = _this.listenerCounter[event] || 0;
            return (_this.listenerSnaps[event] = _this.listenerSnaps[event] || new Set());
        };
        target[options.on] = function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var snaps = init(event);
            if (snaps) {
                _this.listenerCounter[event]++;
                snaps.add(args[0]);
            }
            return on.call.apply(on, __spreadArray([target, event], args, false));
        };
        target[options.off] = function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var snaps = init(event);
            if (snaps && snaps.has(args[0])) {
                _this.listenerCounter[event]--;
                snaps.delete(args[0]);
            }
            return off.call.apply(off, __spreadArray([target, event], args, false));
        };
        if (options.autoStartLog) {
            this.startLog();
        }
    }
    ListenerMonitor.prototype.startLog = function () {
        var _this = this;
        this.stopLog();
        this._timer = setInterval(function () {
            _this.print();
        }, this.options.interval);
    };
    ListenerMonitor.prototype.stopLog = function () {
        this._timer && clearInterval(this._timer);
    };
    ListenerMonitor.prototype.print = function () {
        console.table(this.listenerCounter);
    };
    return ListenerMonitor;
}());
export { ListenerMonitor };
//# sourceMappingURL=listener-monitor.js.map